import { Injectable } from '@angular/core';

import { QuickDepositConfig } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { SyncUserSettingsService } from '@frontend/sports/user/feature';
import { CashierService } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { RedirectHelperService } from 'packages/sports/web/app/src/navigation-core/redirect-helper.service';
import { NumpadDisplayService } from 'packages/sports/web/app/src/numpad/numpad-display.service';

import { IBetslipRootState } from '../../../../../../base/store/state';
import { QuickDepositService } from '../../../../../quick-deposit/services/quick-deposit.service';
import BetslipErrorsActions from '../../../../../validation/actions';
import { PlaceButtonActionHandlerService } from '../../place-button-action-handler.service';
import { PlaceButtonTracking, PlaceButtonTrackingService } from '../../place-button-tracking.service';
import { PlaceButtonActionPredicate } from '../interfaces/place-button-interfaces';

@Injectable()
export class LinearPlaceButtonActionHandlerService extends PlaceButtonActionHandlerService {
    constructor(
        store: Store<IBetslipRootState>,
        userSettings: SyncUserSettingsService,
        loggerFactory: LoggerFactory,
        redirectHelper: RedirectHelperService,
        cashierService: CashierService,
        placeButtonTrackingService: PlaceButtonTrackingService,
        quickDepositService: QuickDepositService,
        quickDepositConfig: QuickDepositConfig,
        numpadDisplayService: NumpadDisplayService,
    ) {
        super(
            store,
            loggerFactory,
            redirectHelper,
            cashierService,
            placeButtonTrackingService,
            quickDepositService,
            quickDepositConfig,
            numpadDisplayService,
            userSettings,
        );
    }

    override getAcceptChangesHandler(): PlaceButtonActionPredicate {
        return this.linearAcceptChangesHandler;
    }

    override makeAcceptAndPlaceBetHandler(isFreeBet: boolean): PlaceButtonActionPredicate {
        return () => this.linearAcceptAndPlaceBetHandler(isFreeBet);
    }

    private linearAcceptChangesHandler = () => {
        this.store.dispatch(BetslipErrorsActions.linearAcceptBetslipChanges());

        this.doTracking(PlaceButtonTracking.AcceptChanges);
    };

    private linearAcceptAndPlaceBetHandler(isFreeBet: boolean): void {
        this.store.dispatch(BetslipErrorsActions.linearAcceptBetslipChanges());
        this.placeBet();
        if (isFreeBet) {
            this.doTracking(PlaceButtonTracking.AcceptAndPlaceFreeBet);
        } else {
            this.doTracking(PlaceButtonTracking.AcceptAndPlace);
        }
    }
}
